export const NO_IMAGE_SOURCE = 'https://storage.googleapis.com/reactive_files_eu/no-image.jpg'
